import axios from "axios";
import { getHeader } from "../../utils/utils";
import { API_BASE_URL } from "../../utils/config";

const API_URL = API_BASE_URL + "/permissions";
const IPLOOKUP_URL = API_BASE_URL + "/ip_lookup";

class otherService {
  getPermissionsList(token) {
    return axios.get(API_URL, {
      headers: getHeader(token),
    });
  }

  ipLookUp(token, hostname) {
    return axios({
      method: "post",
      url: IPLOOKUP_URL,
      headers: getHeader(token),
      data: { hostname: hostname },
    });
  }
}

export default new otherService();
